import FormClients from "../FormClients/FormClients";
import CadastroContainer from "../../../components/CadastroContainer/CadastroContainer";
import { useLocation } from "react-router-dom";
import "./CadastroClientes.css";
import { useEffect, useState } from "react";

const CadastroClientes = () => {
  const { state } = useLocation();
  const client = state;
  const [type, setType] = useState("");

  useEffect(() => {
    if (client) {
      setType("edicao");
    } else if (!client) {
      setType("cadastro");
    }
  }, [client]);

  return (
    <CadastroContainer>
      <FormClients client={client} type={type} />
    </CadastroContainer>
  );
};

export default CadastroClientes;
